import { SCENES_MAP } from 'consts/building';
// import { ROUTE_MAP } from 'consts/url';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateWorldParams } from 'store/actions';

// Automatically map AMENITIES_MAP entries
// const amenitiesPathAdapter = Object.entries(AMENITIES_MAP).reduce(
//   (acc, [sceneId, { url }]) => {
//     acc[`/${ROUTE_MAP.amenities.id}/${url}`] = { sceneId };
//     return acc;
//   },
//   {}
// );

// Automatically map APARTMENT_MAP entries with nested children
const scenePathAdapter = Object.entries(SCENES_MAP).reduce(
  (acc, [sceneId, { url }]) => {
    // Add parent route
    acc[`${url}`] = { sceneId };

    return acc;
  },
  {}
);

export const pathAdapter = {
  ...scenePathAdapter,
};

export const useInitPage = (pathname) => {
  const dispatch = useDispatch();

  const { sceneId = '' } = pathAdapter[pathname] || {};

  useEffect(() => {
    if (sceneId) {
      dispatch(updateWorldParams({ sceneId }));
    }
  }, [dispatch, sceneId]);

  return { sceneId };
};
